import { FunctionComponent } from 'react'
import classes from '../index.module.css'
import Icon from '@mdi/react'
import { mdiUndoVariant } from '@mdi/js'
import { Button } from '@material-ui/core'
import ActiveFilter from './ActiveFilter'
import { useOperatorAssignmentContext } from '../ContextProvider'

function createValueFromList (list: [] = [], key = 'title', separator = ' - ') {
  return list.map(el => el[key]).join(separator)
}

function getLocalTime (status) {
  if (!status.changeTime) return

  const date = new Date(`${status.changeDate}T${status.changeTime}z`)
  console.log(date)

  return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`
}

const CurrentStatus: FunctionComponent = () => {
  const { status, resetFilter, partners } = useOperatorAssignmentContext()

  return (
    <div className={classes.currentStatus}>
      <div className={classes.rowBetween}>
        <div className={classes.statusTitle}>وضعیت فعلی</div>
        {status.statusName === 'default' ? (
          <div className={classes.description}>
            موتور در حالت پیش‌فرض قرار دارد
          </div>
        ) : (
          <div className='reset-button'>
            <Button variant='outlined' color='primary' onClick={resetFilter}>
              بازگشت به تنظیمات پیش‌فرض
              <Icon path={mdiUndoVariant} size={1} className={classes.icon} />
            </Button>
          </div>
        )}
      </div>
      <div>
        <span className={classes.label}>زمان تغییر وضعیت:</span>
        {status.changeDate && (
          <span className={classes.secondColor}>
            {new Date(status.changeDate).toLocaleDateString('fa-IR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}{' '}
            ساعت {getLocalTime(status)}
          </span>
        )}
      </div>
      <div className={classes.activeFilters}>
        <span>فیلتر‌های تنظیم شده:</span>
        {status.statusName &&
          (status.statusName === 'default' ? (
            <Button variant='contained'>{status.statusTitle}</Button>
          ) : (
            <>
              <ActiveFilter
                label={'تاریخ'}
                value={createValueFromList(status.dateTypes)}
              />
              <ActiveFilter
                label={'شرکت'}
                value={`${ partners?.length===status?.partners?.length?'همه شرکت‌ها': status?.partners?.length + ` شرکت انتخاب شده `} `}
              />
              <ActiveFilter
                label={'نوع سفارش'}
                value={createValueFromList(status.orderTypes)}
              />
              <ActiveFilter
                label={'تعداد سفارش در هر تخصیص'}
                value={status.assignmentCount}
              />
            </>
          ))}
      </div>
    </div>
  )
}

export default CurrentStatus
